// Envoie les extractions mises en file hors réseau, au démarrage de l'appli et au retour du réseau.
import { useEffect } from "react";
import { toast } from "sonner";
import { getSessionToken } from "@/lib/api";
import { viderFile } from "@/lib/extractionQueue";

export default function ExtractionQueue() {
  useEffect(() => {
    const vider = async () => {
      if (!getSessionToken()) return;
      for (const d of await viderFile()) {
        if (d.ok && d.documentId) toast.success(`Extraction prête : ajoutée aux Documents de la parcelle ${d.parcelId}.`);
        else if (d.ok) toast.warning(`Extraction de ${d.parcelId} faite, mais la place manque dans les Documents (100 Mo).`);
        else toast.error(`L'extraction demandée hors réseau pour ${d.parcelId} n'a pas pu être faite.`);
      }
    };
    vider();
    window.addEventListener("online", vider);
    return () => window.removeEventListener("online", vider);
  }, []);
  return null;
}
